import { useMemo } from 'react';
import { PapiDeviation, PapiSellerDiscount } from '@wix/da-papi-types';
import { getDeviationPrice } from '../../../../../utils/deviations';
import { normalizeDiscountPrice } from '../../../../../utils/discounts';

export default function usePaywallDiscount(deviation: PapiDeviation): {
  isDiscountApplied: boolean;
  eligibleDiscount?: PapiSellerDiscount;
  notEligibleDiscounts?: PapiSellerDiscount[];
  allDiscounts: PapiSellerDiscount[];
  dollarPrice?: number;
  dollarPriceAfterDiscount?: number;
  formattedDollarPrice?: string;
  formattedDollarPriceAfterDiscount?: string;
} {
  return useMemo(() => {
    const dollarPrice =
      deviation.premiumFolderData?.dollarPrice || getDeviationPrice(deviation)?.dollarsPrice;
    const eligibleDiscount =
      deviation?.premiumFolderData?.eligibleDiscount ||
      deviation?.extended?.saleDetails?.premiumFolder?.eligibleDiscount;
    const notEligibleDiscounts =
      deviation?.premiumFolderData?.notEligibleDiscounts ||
      deviation?.extended?.saleDetails?.premiumFolder?.notEligibleDiscounts;
    const {
      dollarAmountAfterDiscount: dollarPriceAfterDiscount,
      formattedDollarAmount: formattedDollarPrice,
      formattedDollarAmountAfterDiscount: formattedDollarPriceAfterDiscount,
    } = normalizeDiscountPrice(dollarPrice, eligibleDiscount, {
      optionalDecimalDigits: true,
    });

    // Main purpose of this hook is to memoize the discounts and price calculations
    // but most importantly to keep the reference of all discounts stable
    const allDiscounts = [eligibleDiscount, ...(notEligibleDiscounts || [])].filter(
      Boolean
    ) as PapiSellerDiscount[];

    return {
      isDiscountApplied: !!eligibleDiscount,
      eligibleDiscount,
      notEligibleDiscounts,
      allDiscounts,
      dollarPrice,
      dollarPriceAfterDiscount,
      formattedDollarPrice,
      formattedDollarPriceAfterDiscount,
    };
  }, [deviation]);
}
